export enum NotificationType {
  DEVICE_SYNCING = "DEVICE_SYNCING",
  EMAIL_VERIFICATION = "EMAIL_VERIFICATION",
  FIRMWARE_UPDATE = "FIRMWARE_UPDATE",
}
